export const SuccessIcon = () => (
    <svg
        data-testid={'successIcon'}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM14.1869 10.4749L11.2236 13.2271L10.2694 12.3408C10.1773 12.2553 10.0601 12.2125 9.9178 12.2125C9.77549 12.2125 9.6583 12.2553 9.56623 12.3408C9.47415 12.4263 9.42811 12.5352 9.42811 12.6673C9.42811 12.7995 9.47415 12.9084 9.56623 12.9939L10.8721 14.2067C10.9725 14.3 11.0897 14.3466 11.2236 14.3466C11.3576 14.3466 11.4747 14.3 11.5752 14.2067L14.89 11.128C14.9821 11.0425 15.0281 10.9336 15.0281 10.8015C15.0281 10.6693 14.9821 10.5604 14.89 10.4749C14.7979 10.3894 14.6807 10.3466 14.5384 10.3466C14.3961 10.3466 14.2789 10.3894 14.1869 10.4749Z"
            fill="#2E7D32"
        />
    </svg>
);
